export default __webpack_public_path__ + "static/media/map-p-icon.a9e8a8ff.svg";